import React from "react";
import "./css/AboutUs.css";
import headerBg from "./assets/picOne.png"; // reuse or replace with a relevant image

const CertificationSchemes = () => {
  return (
    <div className="about-us">
      {/* === Header Section === */}
      <section className="about-header">
        <div className="overlay">
          <h1 className="page-title">Certification Schemes – Industrial Research & Training</h1>
          <p className="subtitle">
            The Malawi Bureau of Standards (MBS) implements certification schemes under its Industrial Research and Training division to ensure organizations, products, and personnel comply with national and international standards.
          </p>
          <p className="subtitle">
            These schemes promote quality, safety, and competitiveness across industries in Malawi.
          </p>
        </div>
      </section>

      {/* === Types of Certification Schemes Section === */}
      <section className="intro-section">
        <h2 className="section-title">Types of Certification Schemes</h2>
        <div className="row">
          <div className="col-md-6">
            <ul>
              <li>Management Systems Certification (ISO 9001, ISO 14001, ISO 45001)</li>
              <li>Product Certification for quality, safety, and compliance</li>
              <li>Personnel Certification for technical and professional competencies</li>
              <li>Laboratory and Inspection Body Accreditation</li>
              <li>Sector-specific certification schemes tailored to industry requirements</li>
            </ul>
          </div>
          <div className="col-md-6">
            <ul>
              <li>Environmental and sustainability certification programs</li>
              <li>Health and safety management certification</li>
              <li>Calibration and verification certification schemes</li>
              <li>Continuous improvement and surveillance schemes</li>
              <li>Specialized technical and professional certification programs</li>
            </ul>
          </div>
        </div>
      </section>

      {/* === Benefits Section === */}
      <section className="functions-section">
        <h2 className="section-title">Benefits of Certification Schemes</h2>
        <p>
          MBS certification schemes enhance credibility, improve operational efficiency, ensure compliance with standards, and increase stakeholder confidence. 
          They also support market access, consumer protection, and competitiveness locally and internationally.
        </p>
      </section>

      {/* === Contact Section === */}
      <section className="functions-section">
        <h2 className="section-title">Contact for Certification Schemes</h2>
        <p>
          For inquiries, applications, or additional information about certification schemes, please contact the Industrial Research and Training Certification team at MBS.
        </p>
        <div className="row">
          <div className="col-md-6">
            <ul>
              <li>Email: <a href="mailto:certification@mbs.mw">certification@mbs.mw</a></li>
              <li>Phone: +265 (0) 1 789 777</li>
            </ul>
          </div>
          <div className="col-md-6">
            <ul>
              <li>Office: Malawi Bureau of Standards, P.O. Box 946, Blantyre, Malawi</li>
              <li>Website: <a href="https://www.mbs.mw">www.mbs.mw</a></li>
            </ul>
          </div>
        </div>
        <p className="subtitle">
          The MBS Certification Schemes ensure organizations, products, and personnel meet high standards, strengthening quality, safety, and compliance across Malawi.
        </p>
      </section>

      <br /><br />
    </div>
  );
};

export default CertificationSchemes;
